/**
 * Recipe archive entry.
 *
 * - Popular Recipes carousel (Slick) with prev/next arrows + dots.
 * - Mobile filters modal (same vanilla popup pattern as cart-popup).
 * - Light progressive enhancement: changing "Sort by" submits the filter form.
 *
 * Everything still works without JS via the Filter button / form (all state
 * lives in URL query vars); the popular grid degrades to a static two-up.
 */
import '../sass/recipe-archive.scss';
import './slick-carousel';

const $ = window.jQuery || window.$;

/**
 * Mobile "Filters" modal — open/close, scroll lock, Escape + overlay dismiss.
 */
function initFiltersModal() {
	const modal = document.getElementById( 'recipe-filters-modal' );

	if ( ! modal ) {
		return;
	}

	// The modal is rendered inside .site-content (z-index: 4), which sits below
	// the fixed site header (z-index: 5). Relocating it to <body> lets its own
	// z-index win so the overlay covers the whole viewport, header included.
	document.body.appendChild( modal );

	const root = document.documentElement;

	const openModal = () => {
		modal.classList.add( 'is-open' );
		modal.setAttribute( 'aria-hidden', 'false' );
		root.classList.add( 'disable-scroll' );
	};

	const closeModal = () => {
		modal.classList.remove( 'is-open' );
		modal.setAttribute( 'aria-hidden', 'true' );
		root.classList.remove( 'disable-scroll' );
	};

	document
		.querySelectorAll( '.js-recipe-filters-open' )
		.forEach( ( button ) => button.addEventListener( 'click', openModal ) );

	modal
		.querySelectorAll( '.js-recipe-filters-close' )
		.forEach( ( element ) =>
			element.addEventListener( 'click', closeModal )
		);

	document.addEventListener( 'keydown', ( event ) => {
		if ( event.key === 'Escape' && modal.classList.contains( 'is-open' ) ) {
			closeModal();
		}
	} );
}

/**
 * Toolbar filter dropdowns (<details>): close on outside click / Escape, and
 * keep only one open at a time.
 */
function initDropdowns() {
	const dropdowns = document.querySelectorAll( '.recipe-dropdown' );

	if ( ! dropdowns.length ) {
		return;
	}

	// Opening one dropdown closes the others.
	dropdowns.forEach( ( dropdown ) => {
		dropdown.addEventListener( 'toggle', () => {
			if ( ! dropdown.open ) {
				return;
			}
			dropdowns.forEach( ( other ) => {
				if ( other !== dropdown ) {
					other.removeAttribute( 'open' );
				}
			} );
		} );
	} );

	// A click outside an open dropdown closes it.
	document.addEventListener( 'click', ( event ) => {
		dropdowns.forEach( ( dropdown ) => {
			if ( dropdown.open && ! dropdown.contains( event.target ) ) {
				dropdown.removeAttribute( 'open' );
			}
		} );
	} );

	// Escape closes any open dropdown.
	document.addEventListener( 'keydown', ( event ) => {
		if ( event.key === 'Escape' ) {
			dropdowns.forEach( ( dropdown ) =>
				dropdown.removeAttribute( 'open' )
			);
		}
	} );
}

document.addEventListener( 'DOMContentLoaded', () => {
	const sort = document.querySelector( '.js-recipe-sort' );

	if ( sort ) {
		sort.addEventListener( 'change', () => {
			if ( sort.form ) {
				sort.form.submit();
			}
		} );
	}

	initFiltersModal();
	initDropdowns();

	if ( $ ) {
		const $popular = $( '.recipe-popular__grid' );

		// Only turn it into a carousel when there is more than one slide-worth.
		if ( $popular.length && $popular.children().length > 2 ) {
			$popular.slick( {
				slidesToShow: 2,
				slidesToScroll: 2,
				dots: true,
				appendDots: $( '.recipe-popular__dots' ),
				arrows: true,
				infinite: true,
				autoplay: false,
				responsive: [
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			} );
		}
	}
} );
